module.exports = __webpack_public_path__ + "img/s2P11.263e96c5.png";